import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, ReavaliacaoImovelItem } from 'eddydata-lib';

@Injectable({
  providedIn: 'root'
})
export class ReavaliacaoImovelItemService extends BaseResourceService<ReavaliacaoImovelItem> {

  constructor(
    protected injector: Injector
  ) {
    super(`reavaliacao-imovel-itens`, injector);
  }

}





